import { render } from "./Ticket.vue?vue&type=template&id=fc8d6824"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fc8d6824"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc8d6824', script)) {
    api.reload('fc8d6824', script)
  }
  
  module.hot.accept("./Ticket.vue?vue&type=template&id=fc8d6824", () => {
    api.rerender('fc8d6824', render)
  })

}

script.__file = "src/icons/components/outlined/Ticket.vue"

export default script